import { render } from "./Beneficiaries.vue?vue&type=template&id=710fd27e&scoped=true"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"

import "./Beneficiaries.vue?vue&type=style&index=0&id=710fd27e&lang=css"
import "./Beneficiaries.vue?vue&type=style&index=1&id=710fd27e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710fd27e"]])

export default __exports__